import {axiosService} from "./axios.service";
import {endPoints} from "../configs/urls";

const offerService = {
    create: async (data) => {
        try {
            const res = await axiosService.post(endPoints.offer.base, data);

            return res;
        } catch (error) {
            throw error;
        }
    },
    getByCurrentUser: async () => {
        try {
            const res = await axiosService.get(endPoints.offer.byCurrentUser);

            return res;
        } catch (error) {
            throw error;
        }
    },
    getById: async (id) => {
        try {
            const res = await axiosService.get(`${endPoints.offer.base}${id}/`);

            return res;
        } catch (error) {
            throw error;
        }
    },
    deleteById: async (id) => {
        try {
            const res = await axiosService.delete(`${endPoints.offer.base}${id}/`);

            return res;
        } catch (error) {
            throw error;
        }
    },
    getAll: async () => {
        try {
            const res = await axiosService.get(endPoints.offer.base);

            return res;
        } catch (error) {
            throw error;
        }
    }
}

export {
    offerService,
}
